import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { clearCart} from '../store/cartSlice';
import { useDispatch, useSelector } from 'react-redux';


const PaymentComponent = (props) => {
  const [isLoading, setIsLoading] = useState(false);

  let navigate = useNavigate();
  const dispatch = useDispatch();
  const {cartItems, discount, subtotal, totalPrice, formData,setPaymentState} = props

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  function isOnlyLetters(word) {
    return /^[A-Za-z]+$/.test(word);
}

function isTenDigitNumber(value) {
    return /^\d{10}$/.test(value);
}
function isEmpty(str) {
    return !String(str) || String(str).trim().length === 0;
  }

  async function callBackend(phone, cart, total, subtotal, discount){
    let response;
      try{
        response = await fetch ("api/sales",{
                     
                     method: "POST",
                     headers:{
                        "Content-Type": "application/json"
                     },
                     body: JSON.stringify({
                        customerPhone: phone,
                        cart: cart,
                        total: total,
                        subtotal: totalPrice,
                        discount: discount
                     })

                 })
    return response
      }catch(error){
              console.error('sale failed to record', error);
      }
  }
  


  const handlePayButtonClick = () => {
      setPaymentState({state:'pending'})
     if (window.fbq) {
        window.fbq('track', 'InitiateCheckout', {
            value: subtotal,
            currency: "ZMW",
            content_ids: cartItems.map(item => item.id),
            content_type: 'product'
        });
    }


      let firstName = "Jane"
      let lastName = "Doe"
      let email = "JaneDoe@gmail.com"
     const {phone} = formData
    if(isEmpty(firstName) || isEmpty(lastName) || isEmpty(email) || isEmpty(phone)){
        alert("please fill in all inputs")
        return
    }
    
    if(!isOnlyLetters(firstName) || !isOnlyLetters(lastName) || !isValidEmail(email) || !isTenDigitNumber(phone)){
        alert("kindly ensure that last name is only text, first name is only text, email is a valid email address and phone number is 10 digits")
        return
    }

    if(cartItems.length == 0){
        alert("can't make payment for empty cart")
    }
    if(isEmpty(subtotal)){
        alert("kindly select items and add them to cart")
    }

      setIsLoading(true); 
    if (window.LencoPay) {

      initializeLenco(); 
      setIsLoading(false); 
      return;
    }

    const existingScript = document.querySelector('script[src="https://pay.lenco.co/js/v1/inline.js"]');
    if (existingScript) {
      setIsLoading(false);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://pay.lenco.co/js/v1/inline.js';
    script.async = true;

    script.onload = async () => {
      if (window.LencoPay) {
          
        initializeLenco(email,firstName,lastName,phone)
         //phone, cart, total, subtotal, discount
        let res = await callBackend(phone, cartItems, totalPrice, subtotal, discount)
        if(res.status == 500){
            setPaymentState({state: 'error', message : res.statusText})
        }else if(res.status == 400){
            setPaymentState({state: "can't connect", message : "A connection cannot be made"})
        }else if(res.status == 201){
             initializeLenco(email,firstName,lastName,phone); 
             setPaymentState({state: "success", message : "sale successfully made", items: {cartItems: cartItems, total: totalPrice, subtotal: subtotal, discount: discount}})
        }else{
            setPaymentState({state: "error", message : "an error happened"})
        }
        dispatch(clearCart())
        //initializeLenco(email,firstName,lastName,phone);
      }
      setIsLoading(false);
    };

    document.body.appendChild(script);
  };

  const initializeLenco = (email,firstName,lastName,phone) => {
    window.LencoPay.getPaid({
		key: 'pub-dff572a3b0acb046dae6bd0d9ac427bb9ae179794f6e0d80',
		reference: 'ref-' + Date.now(),
		email: email,
		amount: totalPrice,
		currency: "ZMW",
		channels: ["card", "mobile-money"],
		customer: {
			firstName: firstName,
			lastName: lastName,
			phone: String(phone),
		},
		onSuccess: async function (response) {
			const reference = response.reference;
			alert('Payment complete! Reference: ' + reference);
            let saleItem = {
                cartItems: cartItems,
                ref: reference,
                formData: formData,
                discount: discount,
                subtotal: subtotal,
                totalPrice: totalPrice
            }

            if (window.fbq) {
            window.fbq('track', 'Purchase', {
                value: totalPrice,              // total amount paid
                currency: "ZMW",
                content_ids: cartItems.map(item => item.id),
                content_type: 'product'
            });
            console.log('Purchase fired for reference', reference);
        }

            navigate(`/payment`, {state:{saleItem:saleItem}})
		},
		onClose: function () {
			alert('Payment was not completed, window closed.');
		},
		onConfirmationPending: function () {
			alert('Your purchase will be completed when the payment is confirmed');
		},
	});
  };

  return (
    <div>
      <button id="lenco-pay-button" onClick={handlePayButtonClick} disabled={isLoading} className='pay-btn'>
       <p className='text'> {isLoading ? 'Loading...' : 'Make Payment'}</p>
      </button>
    </div>
  );
};

export default PaymentComponent;